import { useReducer } from 'react';
export function useLocalStorage(...localStorageKeys) {
    return useReducer((_, newValue) => {
        if (newValue === null) {
            const firstKey = localStorageKeys[0];
            if (firstKey) {
                window.localStorage.removeItem(firstKey);
            }
        }
        else {
            localStorageKeys.forEach((key) => window.localStorage.setItem(key, newValue));
        }
        return newValue;
    }, null, () => {
        for (const key of localStorageKeys) {
            const value = window.localStorage.getItem(key);
            if (value !== null) {
                return value;
            }
        }
        return null;
    });
}
//# sourceMappingURL=useLocalStorage.js.map